const minNumber = (formValue, checkValue) =>
    Number(formValue) >= Number(checkValue);

const maxNumber = (formValue, checkValue) =>
    Number(formValue) <= Number(checkValue);

const validate = (formValue, type, checkValue) => {
    switch (type) {
        case 'MIN_NUMBER_VALUE':
            return minNumber(formValue, checkValue);
        case 'MAX_NUMBER_VALUE':
            return maxNumber(formValue, checkValue);
        default:
            return true;
    }
};

const getError = (formValue, type, checkValue, errorString) => {
    switch (type) {
        case 'MIN_NUMBER_VALUE':
            return minNumber(formValue, checkValue) !== true
                ? { id: type, msg: errorString }
                : null;
        case 'MAX_NUMBER_VALUE':
            return maxNumber(formValue, checkValue) !== true
                ? { id: type, msg: errorString }
                : null;
        default:
            return null;
    }
};

export const ValidatorService = {
    checkValues: (formValue, validators) => {
        const results = validators.map(validator =>
            validate(formValue, validator.type, validator.value)
        );
        const success = results.every(e => e);
        if (success) {
            return success;
        }

        return false;
    },
    getErrors: (formValue, validators) => {
        const errors = validators.map(validator =>
            getError(
                formValue,
                validator.type,
                validator.value,
                validator.errorString
            )
        );

        return errors;
    },
};
